import { SIZES } from 'common/constants/sizes';
import styled from 'styled-components';

export const StyledWizardFooter = styled.footer`
  display: flex;
  right: 0;
  position: absolute;
  bottom: 2rem;
  right: 0.7rem;
  & button {
    margin-right: 1rem;
  }
`;

export const StyledSyncGitTeamsWizard = styled.div`
  font-size: ${SIZES['medium']};
  height: 100%;
`;
